// extracted by mini-css-extract-plugin
export default {"container":"leader_container__3uLxo","position":"leader_position__3gDF-","points":"leader_points__bTa72","player":"leader_player__2WlfB","defisTheme":"leader_defisTheme__253FF"};